import { useEffect, useState } from "react";
import parse from "html-react-parser";
import CmModal from "../Controls/CmModal";
import CustomButton from "../Controls/CustomButton";
import { decodeAgreementHtml } from "../Controls/agreementContent";

function renderAgreementContent(raw) {
  if (!raw || typeof raw !== "string") return null;
  if (/<\/?[a-z][\s\S]*>/i.test(raw)) {
    return parse(raw);
  }
  return <pre className="agreementContent">{raw}</pre>;
}

/**
 * Read-only agreement content viewer (Account lists).
 * Signing still uses the AgreementSignature page.
 */
export default function AgreementDetailsModal({ agreement, onClose }) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const raw = agreement?.Content || agreement?.content || "";
    setContent(renderAgreementContent(decodeAgreementHtml(raw)));
  }, [agreement]);

  const title = agreement?.Name || agreement?.name || "Agreement Details";
  const version =
    agreement?.Version ||
    (agreement?.MajorVersion != null
      ? `${agreement.MajorVersion}.${agreement.MinorVersion ?? 0}`
      : null);

  return (
    <CmModal
      open
      onClose={onClose}
      title={title}
      size="wide"
      testId="agreement-details-modal"
      className="agreement-details-modal"
      footer={
        <CustomButton type="button" variant="contained" color="primary" onClick={onClose}>
          Close
        </CustomButton>
      }
    >
      {!agreement ? (
        <p>Agreement not found.</p>
      ) : (
        <div>
          {version ? <p className="fieldHint">Version {version}</p> : null}
          <div className="agreementContent">{content}</div>
        </div>
      )}
    </CmModal>
  );
}
